import { useState, useEffect } from 'react';

const IMAGE_LIST = {
  background: '/img/two_players_back.png',
  white_piece: '/img/white_got.png',
  black_piece: '/img/black_got.png',
  white_highlight: '/img/white_highlight.png',
  black_highlight: '/img/black_highlight.png',
  white_beard_off: '/img/white_beard_off.png',
  black_beard_off: '/img/black_beard_off.png',
  dice_button: '/img/dice_button.png',
  active_dice_button: '/img/active_dice_button.png',
  player2_dice: '/img/inactive_player2_dice.png',
  active_player2_dice: '/img/active_player2_dice.png',
  blank_dice: '/img/blank.png',
  blank_cpu: '/img/blank_cpu.png',
  destination_light: '/img/destination_light.png',
  destination_light_bottom: '/img/destination_light_bottom.png',
  turn_light: '/img/turn_light.png',
  bearing_off_light: '/img/bearing_off_light.png',
  white_wins: '/img/white_wins.png',
  black_wins: '/img/black_wins.png',
  start: '/img/start.png',
  how_to_play: '/img/how_to_play.png',
  rules: '/img/rules.png',
  you_dice_1: '/img/you_dice_1.png',
  you_dice_2: '/img/you_dice_2.png',
  you_dice_3: '/img/you_dice_3.png',
  you_dice_4: '/img/you_dice_4.png',
  you_dice_5: '/img/you_dice_5.png',
  you_dice_6: '/img/you_dice_6.png',
  cpu_dice_1: '/img/cpu_dice_1.png',
  cpu_dice_2: '/img/cpu_dice_2.png',
  cpu_dice_3: '/img/cpu_dice_3.png',
  cpu_dice_4: '/img/cpu_dice_4.png',
  cpu_dice_5: '/img/cpu_dice_5.png',
  cpu_dice_6: '/img/cpu_dice_6.png',
};

export default function useImageLoader() {
  const [images, setImages] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const imgMap = {};
    let count = 0;
    const total = Object.keys(IMAGE_LIST).length;

    Object.entries(IMAGE_LIST).forEach(([key, src]) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        imgMap[key] = img;
        count++;
        if (count === total) {
          setImages(imgMap);
          setLoaded(true);
        }
      };
      img.onerror = () => {
        console.warn(`Failed to load: ${src}`);
        imgMap[key] = null;
        count++;
        if (count === total) {
          setImages(imgMap);
          setLoaded(true);
        }
      };
    });
  }, []);

  return { images, loaded };
}
